orders-planner-dialog-update-under(class="{show: isShow}")
  .orders-planner-dialog-update-under.popper
    forms-orders-under(tag-scope="forms_orders_under")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.update-under');
  style(scoped).
    forms-orders-under inputs-complex-radio-under label.col-md-4,
    forms-orders-under inputs-submit{
      display: none;
    }
    forms-orders-under inputs-complex-radio-under .col-md-8 {
      max-width: 100% !important;
      flex: 100% !important;
    }
    forms-orders-under .form-group {
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
    }
